// src/features/security/components/SecuritySessionsCard.tsx
import { Card } from '../../../app/components/foundation';
import type { SecuritySession } from '../data/security.mock';

export interface SecuritySessionsCardProps {
  sessions: SecuritySession[];
}

/**
 * Workspace card: active sessions tied to this module — device, IP,
 * and last activity. Rows come straight from the `sessions` prop
 * (sourced via useSecurityWorkspaceMock) — no fetching here. Same
 * list markup as customers/components/CustomerOrdersCard.tsx.
 */
export function SecuritySessionsCard({ sessions }: SecuritySessionsCardProps) {
  return (
    <Card className="vania-security-workspace-card">
      <h2 className="vania-security-workspace-card-title">نشست‌های فعال</h2>

      {sessions.length === 0 ? (
        <p className="vania-security-workspace-empty">نشست فعالی برای این ماژول ثبت نشده است.</p>
      ) : (
        <ul className="vania-security-workspace-list">
          {sessions.map((session) => (
            <li key={session.id} className="vania-security-workspace-list-item">
              <span className="vania-security-workspace-list-primary">{session.device}</span>
              <span className="vania-security-workspace-list-secondary" dir="ltr">
                {session.ip}
              </span>
              <span className="vania-security-workspace-list-secondary">{session.lastActivity}</span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
